import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepAccessGuard } from '../shared/guards/step-access.guard';
import { StepPageResolver } from '../shared/resolvers/step-page.resolver';
import { ROUTES } from '../shared/utils/routes';
import { LandingComponent } from './components/landing.component';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    data: {
      route: ROUTES.landing,
    },
    resolve: {
      cmsPage: StepPageResolver,
    },
    canActivate: [StepAccessGuard],
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
})
export class LandingRoutingModule {}
